import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NumberWithPercent = _resolveComponent("NumberWithPercent")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.hideRequestsColumn)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createTextVNode("—")
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$n(_ctx.data.requests)), 1),
          (_ctx.showExtraData)
            ? _withDirectives((_openBlock(), _createBlock(_component_NumberWithPercent, {
                key: "requests_no_ads",
                number: _ctx.data.requests_no_ads,
                "number-percent": _ctx.data.requests_no_ads_percent
              }, null, 8, ["number", "number-percent"])), [
                [
                  _directive_tooltip,
                  _ctx.$t('no_ads'),
                  void 0,
                  { left: true }
                ]
              ])
            : _createCommentVNode("", true),
          (_ctx.showExtraData)
            ? _withDirectives((_openBlock(), _createBlock(_component_NumberWithPercent, {
                key: "requests_bounces",
                number: _ctx.data.requests_bounces,
                "number-percent": _ctx.data.requests_bounces_percent
              }, null, 8, ["number", "number-percent"])), [
                [
                  _directive_tooltip,
                  _ctx.$t('bounces'),
                  void 0,
                  { left: true }
                ]
              ])
            : _createCommentVNode("", true)
        ], 64))
  ]))
}